export default function GetHomeValue()
{
    return (
        <h1>Get Home Value</h1>
    )
}